import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Injector,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Router, RouterLink } from '@angular/router';
import { LinkService } from '@core/services/link.service';
import { SessionService } from '@core/services/session.service';
import { WorksheetService } from '@home/service/worksheet.service';
import { takeWhile } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AODA } from '../../../core/utilities/aoda';
import { LanguageType } from '../../models/common/language-type.enum';
import { BaseComponent } from '../base.component';
import {MessageConstants} from "@shared/constants/message.constants";
import {MessageService} from "@shared/services/message.service";
import { TitleService } from '@shared/services/title.service';
import { AutofocusDirective } from '../../directives/autofocus.directive';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatNavList, MatListItem } from '@angular/material/list';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSidenavContainer, MatSidenav, AutofocusDirective, MatToolbar, MatToolbarRow, MatIconButton, MatTooltip, MatIcon, MatNavList, MatListItem, MatSidenavContent, RouterLink, AsyncPipe, TranslatePipe]
})
export class TopNavComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('drawer', { static: true }) public drawer: MatSidenav;
  sideNavOpened: boolean;

  get routerLinkHome() {
    return this.isAuthenticated ? '/secure-home' : '/';
  }

  get oppositeLanguage() {
    const preference = this.cache.preference;
    return preference.languageType === LanguageType.English ? LanguageType.French : LanguageType.English;
  }

  get allowCreateNew() {
    const worksheetTypes = this.cache.worksheetTypes;
    const url = window.location.href;
    return worksheetTypes ? !worksheetTypes.find(v => url.toUpperCase().indexOf(v.typeName.toUpperCase()) > -1) : false;
  }

  get version() {
    return environment.isProdEnv ? undefined : 'Commit 5be714bd2 (2026-11-02)';
  }

  get navTitle() {
    return this.titleService.navTitle$();
  }

  constructor(
    private readonly injector: Injector,
    public router: Router,
    private readonly session: SessionService,
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    private readonly linkService: LinkService,
    private readonly worksheetService: WorksheetService,
	  private readonly messageService: MessageService,
    titleService: TitleService
  ) {
    super(injector);
  }

  ngAfterViewInit() {
    AODA.applyAllFixes(this.el, this.renderer, this.languageService.languageType);
  }

  logout() {
    this.session.logout();
  }

  login() {
    this.session.login();
  }

  signup() {
    this.session.signup();
  }

  forgotPassword() {
    return this.session.forgotPassword();
  }

  home() {
    this.sideNavOpened = !this.sideNavOpened;
    this.session.home();
  }

  contactUs() {
    this.sideNavOpened = false;
    this.linkService.contactUs();
  }

  feedback() {
    this.sideNavOpened = false;
    this.linkService.feedback();
  }

  switchLanguage() {
    this.session
      .switchLanguage()
      .pipe(takeWhile(() => this.alive))
      .subscribe();
  }

  createNew(): void {
    this.sideNavOpened = !this.sideNavOpened;
    this.worksheetService.create().subscribe();
  }

	import(): void
	{
		this.sideNavOpened = !this.sideNavOpened;

		this.messageService.sendMessage(MessageConstants.IMPORT_WORKSHEET);
	}
}
